import {
  DESTINATION_OPTIONS,
  INTEGRATION_OPTIONS,
  PAGER_DUTY,
} from '@elementary/common-ui/constants/queryKeys';
import { MutationError } from '@elementary/common-ui/types/mutationTypes';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import * as api from '../../services/settingsApi';
import useSnackbar from '../useSnackbar';
import useSendTracking from './useSendTracking';

const usePagerDutyIntegration = () => {
  const queryClient = useQueryClient();
  const { openSnackbar } = useSnackbar();

  const { tracking, trackingEvents, sendTrackingWithoutSensitiveData } =
    useSendTracking();

  const pagerDutyQuery = useQuery([PAGER_DUTY], () => api.fetchPagerDuty(), {});

  const pagerDutyIntegrationMutation = useMutation(
    () => api.setPagerDutyIntegration(),
    {
      onSuccess: () => {
        queryClient.invalidateQueries([PAGER_DUTY]);
        queryClient.invalidateQueries([DESTINATION_OPTIONS]);
        queryClient.invalidateQueries([INTEGRATION_OPTIONS]);
        openSnackbar({
          message: 'Successfully connected to your PagerDuty',
          variant: 'success',
        });
        tracking?.sendTrackingEvent({
          eventName: trackingEvents?.CONNECT_PAGERDUTY_INTEGRATION_SUCCESSFULLY,
        });
      },
      onError: (error: MutationError) =>
        sendTrackingWithoutSensitiveData({
          error,
          eventName: trackingEvents?.CONNECT_PAGERDUTY_INTEGRATION_FAILURE,
        }),
    },
  );

  return {
    pagerDutyQuery,
    pagerDutyIntegrationMutation,
    isPagerDutyConnected: !!pagerDutyQuery.data?.integrated,
  };
};

export default usePagerDutyIntegration;
